import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "m-auto mt-8 w-6/12 border-2 rounded-md p-2 bg-hub-background-3 text-center"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mt-8" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }

import App from '@/pages/App.vue';
	import { ref, onMounted } from 'vue';

	enum State {
		Initial,
		Access,
		NoAccess,
		RequestingAccess,
		RequestDenied,
	}

	
export default /*#__PURE__*/_defineComponent({
  __name: 'AppWrapper',
  setup(__props) {

	const state = ref(State.Initial);

	onMounted(async () => {
		console.assert(state.value === State.Initial);

		if (await hasStorageAccess()) {
			state.value = State.Access;
		} else {
			state.value = State.NoAccess;
		}
	});

	async function hasStorageAccess(): Promise<boolean> {
		if (!document.hasStorageAccess) {
			// If there's no document.hasStorageAccess,
			// there's likely no third-party tracking cookie blocking
			return true;
		}
		return await document.hasStorageAccess();
	}

	async function requestStorageAccess(): Promise<boolean> {
		try {
			await document.requestStorageAccess();
			return true;
		} catch (error) {
			console.warn(`storage access rejected with error ${error}`);
		}
		return false;
	}

	async function onButton() {
		console.assert(state.value === State.NoAccess);
		state.value = State.RequestingAccess;

		if (await requestStorageAccess()) {
			state.value = State.Access;
		} else {
			state.value = State.RequestDenied;
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_Logo = _resolveComponent("Logo")!

  return (state.value === State.Access)
    ? (_openBlock(), _createBlock(App, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Logo, { class: "mb-8 w-6/12 m-auto" }),
        (state.value === State.NoAccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('state.no_access')), 1),
              _createElementVNode("p", _hoisted_3, [
                _createElementVNode("button", {
                  class: "mx-1 py-1 px-2 border rounded-md bg-green",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onButton()))
                }, _toDisplayString(_ctx.$t('state.button_request')), 1)
              ])
            ]))
          : (state.value === State.Initial)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('state.initial')), 1)
              ]))
            : (state.value === State.RequestingAccess)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('state.requesting')), 1)
                ]))
              : (state.value === State.RequestDenied)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('state.denied')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('state.woops')), 1)
                  ]))
      ]))
}
}

})